import React from 'react'
import { useCreateCustomSection } from 'hooks/api/useSprintPackets'
import { radius, SurfacePalette, type } from '../../tokens'

interface Props {
  palette: SurfacePalette
  packetID: number
}

/**
 * Adds an AE-authored slide. It always lands at the end of the deck — which is
 * exactly where this button sits — and the AE arrows it wherever they want. A
 * placement picker would be a choice made before there's anything to place.
 */
export const AddCustomSectionButton = ({ palette, packetID }: Props) => {
  const create = useCreateCustomSection(packetID)

  return (
    <button
      type="button"
      onClick={() => create.mutate()}
      disabled={create.isLoading}
      style={{
        width: '100%',
        padding: '14px 28px',
        borderRadius: radius.lg,
        border: `1px dashed ${palette.hairline}`,
        background: 'transparent',
        color: palette.textMuted,
        fontFamily: type.family.sans,
        fontSize: type.size.body,
        cursor: create.isLoading ? 'default' : 'pointer',
      }}
    >
      {create.isLoading ? 'Adding…' : '+ Add a slide'}
    </button>
  )
}
